import React from 'react'
import { Drawer, Hidden, makeStyles, Theme } from '@material-ui/core'

type StyleProps = {
  isExtended?: boolean
  omitPadding?: boolean
}

const width = 350
const extendedWidth = 425

const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  drawer: {
    width: (props) => (props.isExtended ? extendedWidth : width),
    flexShrink: 0,
  },
  drawerPaper: {
    width: (props) => (props.isExtended ? extendedWidth : width),
  },
  drawerContainer: {
    overflow: 'auto',
    padding: (props) => (props.omitPadding ? '0' : theme.spacing(2)),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
}))

type Props = {
  children: React.ReactNode
  isExtended?: boolean
  omitPadding?: boolean
}

export function Sidebar({
  children,
  isExtended,
  omitPadding,
}: Props): React.ReactElement {
  const classes = useStyles({ isExtended, omitPadding })

  return (
    <Hidden smDown>
      <Drawer
        className={classes.drawer}
        classes={{ paper: classes.drawerPaper }}
        variant="permanent"
      >
        <div className={classes.drawerContainer}>{children}</div>
      </Drawer>
    </Hidden>
  )
}
